import { useRouter } from "next/router";
import queryString from "query-string";
import React from "react";

const SavedSearchQueryParams = {
  year: "year",
  player: "player",
  set: "set",
  sport: "sport",
  variation: "variation",
  set_variation: "set_variation",
  number: "number",
  other_terms: "other_terms",
  exclude_terms: "exclude_terms",
  grade: "grade",
  exclude_lots: "exclude_lots",
  exclude_sealed: "exclude_sealed",
  exclude_breaks: "exclude_breaks",
  other_terms_new_item: "other_terms_new_item",
  exclude_terms_new_item: "exclude_terms_new_item",
  // For Popular Card Charts
  players: "players",
  sets: "sets",
  variations: "variations",
  set_variations: "set_variations",
  years: "years",
  grades: "grades",
  // Sets
  sports: "sports",
  // Combined set names with year
  set_name_years: "set_name_years",
  // For Sealed Wax
  box_types: "box_types",
  sealed_type: "sealed_type",
  cid: "cid",
  cids: "cids",
};

const withSavedSearchQueryParams = (WrappedComponent) => (props) => {
  const searchQueryParamsKeys = Object.keys(SavedSearchQueryParams);

  const router = useRouter();
  const queryParams = {};
  let hasQueryParams = false;
  searchQueryParamsKeys.forEach((key) => {
    if (router.query[key]) {
      switch (key) {
        case SavedSearchQueryParams.players:
        case SavedSearchQueryParams.sets:
        case SavedSearchQueryParams.variations:
        case SavedSearchQueryParams.set_variations:
        case SavedSearchQueryParams.years:
        case SavedSearchQueryParams.box_types:
        case SavedSearchQueryParams.grades:
        case SavedSearchQueryParams.sports:
        case SavedSearchQueryParams.set_name_years:
          // Break apart params, make sure everything has a length
          queryParams[key] = router.query[key].split(",").filter((a) => a.length);
          break;
        default:
          queryParams[key] = router.query[key];
          break;
      }
      hasQueryParams = true;
    }
  });

  let stringifiedSearch;
  if (hasQueryParams) {
    const query = router.query;

    delete query.years;
    if (query.set_name_years) {
      query.sets = query.set_name_years;
      delete query.set_name_years;
    }

    stringifiedSearch = queryString.stringify(query, { encode: false });
  }

  return (
    <WrappedComponent
      {...props}
      stringifiedSearch={stringifiedSearch}
      queryParams={queryParams}
      hasQueryParams={hasQueryParams}
      isQueryRcOnly={router.query.rc_only}
    />
  );
};

export default withSavedSearchQueryParams;
export { SavedSearchQueryParams };
